import React from "react";
import { Modal } from "antd";
import Localize from "../../libs/localization";

/**
 * Error Modal Component
 *
 * Displays errors in a consistent modal format with automatic localization handling.
 * Handles both ErrorMessage objects with getLocalizedDescription() and regular error objects.
 *
 * @param {Object} error - The error object to display
 * @param {Object} options - Optional configuration
 * @param {string} options.title - Custom title (defaults to "COMMON.ERROR")
 * @param {string} options.width - Modal width (defaults to "400px")
 * @param {Function} options.onOk - Callback when OK is clicked
 */
const ErrorModal = {
  show: (error, options = {}) => {
    const { title = "COMMON.ERROR", width = "400px", onOk = null } = options;

    let content;

    // Check if error has the getLocalizedDescription method
    if (error && typeof error.getLocalizedDescription === "function") {
      content = error.getLocalizedDescription();
    } else {
      // Fallback to unexpected error for any error without localization
      content = Localize("ERROR_ID.UNEXPECTED");
    }

    Modal.error({
      title: Localize(title),
      content,
      width,
      onOk,
    });
  },
};

export default ErrorModal;
